/**
 * Filter an array down to unique values by accepting only the first iteration of it's values
 */
export const unique = ({ arr }) => arr.filter((item, index) => arr.indexOf(item) === index)
